export default __webpack_public_path__ + "static/media/logo.c6e87a69.png";